import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-cadastro-em-analise',
  templateUrl: './cadastro-em-analise.component.html',
  styleUrls: ['./cadastro-em-analise.component.scss'],
})
export class CadastroEmAnaliseComponent { }
